/**
 * Iniciais do avatar na tela de usuários: só letras contam, então "Carla (secretária)"
 * vira "CS" e nunca "C(". Sem nenhuma letra, "?".
 */
const LETTER = /\p{L}/u;

const personInitials = (name) => {
  // E-mail no lugar do nome: só a parte antes do @
  const words = String(name || '')
    .replace(/@.*$/, '')
    .split(/[\s._-]+/)
    .map((word) => Array.from(word).find((char) => LETTER.test(char)))
    .filter(Boolean);
  if (words.length === 0) return '?';
  if (words.length === 1) return words[0].toUpperCase();
  return (words[0] + words[words.length - 1]).toUpperCase();
};

export default personInitials;
